import { AttestationSummary } from '@/typings';
import { adaptDecimalValueToPercentage } from '../utilities';
import { GetSummaryResponseDTO } from '@/api/section/DTOs';

export const adaptGetSummaryResponseToSectionSummary = (
  sectionSummaryResponse: GetSummaryResponseDTO,
): AttestationSummary => {
  return {
    fieldsCount: sectionSummaryResponse.section.fieldsCount,
    pendingFieldsCount: sectionSummaryResponse.section.pendingFieldsCount,
    requiredFieldsCount: sectionSummaryResponse.section.requiredFieldsCount,
    pendingRequiredFieldsCount:
      sectionSummaryResponse.section.pendingRequiredFieldsCount,
    restrictionViolationsCount:
      sectionSummaryResponse.section.restrictionViolationsCount,
    completedPercentage: adaptDecimalValueToPercentage(
      sectionSummaryResponse.section.completedPercentage,
    ),
  };
};
